import React, { useRef, useEffect, useCallback, useState} from 'react';
import {setPackToEdit} from 'actions/index.js';
import {newPack} from 'packs/packs.js';
import PackContent from "components/packs/PackContent.js";
import {
    setSampleDragging,
    setPresetDragging,
    setDraggingPackWindow,
    setCreatingNewPack
       } from 'actions/index.js';
import {connect} from 'react-redux';

const NewPackWindow = ({
    creatingNewPack,
    position,
    sampleDragging,
    setSampleDragging,
    setPresetDragging,
    setCreatingNewPack,
    setDraggingPackWindow,
    setPackToEdit,
    presetDragging,
    json={title:"", samples:[], description:"", presets: []}
}) => { 
    const [samples, setSamples] = useState(json.samples || []);
    const [presets, setPresets] = useState(json.presets || []);
    const [name, setName] = useState(json.title);
    const [description, setDescription] = useState(json.description);

    useEffect(() => {
        if (creatingNewPack && creatingNewPack.name) {
            // then its a sample that we should add
            setSamples([creatingNewPack]);
        } else if (creatingNewPack && creatingNewPack.title) {
            setPresets([creatingNewPack]);
        }
    }, [creatingNewPack]);

    const ref = useRef(undefined);
    const onMouseDown = useCallback((e) => {
        let rect = ref.current.getBoundingClientRect();
        let x = e.clientX - rect.left;
        let y = e.clientY - rect.top;
        setDraggingPackWindow({x,y});
    }, []);

    const onClickSave = useCallback((e) => {
        newPack(
            name,
            description,
            samples.map(s => s.getId()),
            presets.map(x => x.contentHash),
            json.packHash);
        setCreatingNewPack(false);
        setPackToEdit(undefined);
    }, [name, description, samples, presets, json]);

    const onDrop = useCallback((e) => {
        e.stopPropagation();

        if (sampleDragging) {
            setSamples([... samples, sampleDragging]);
            setSampleDragging(undefined);
        } else if (presetDragging) {
            setPresets([... presets, presetDragging]);
            setPresetDragging(undefined);
        }
    }, [
        sampleDragging,
        setSamples,
        samples,
        presetDragging,
        setPresets,
        presets
    ]);

    const onDelete = useCallback((content) => {
        if (samples.includes(content)) {
            setSamples(samples.filter(x => x !== content));
        } else if (presets.includes(content)) {
            setPresets(presets.filter(x => x !== content));
        }
    }, [samples, setSamples, presets, setPresets]);

    let style = {
        left: position.x,
        top: position.y
    };

    let content = [...samples, ...presets];
    return (
        <div
          style={style}
          onDrop={onDrop}
          ref={ref}
          onMouseDown={onMouseDown}
          onMouseUp={() => setDraggingPackWindow(undefined)}
          className="pack-window no-select">
          <div className="floppy-top">
            <input
              placeholder="Type name here"
              className="pack-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}/>
          </div>
          <div onClick={() => {
              setCreatingNewPack(false);
              setPackToEdit(undefined);
          }} className="delete-btn">x</div>
          {content.length === 0 ? 
          <div className="drop-here">
            Drop sounds and presets here.
          </div> : 
           <div className="contents">
             {samples.map(
                 sample =>
                     <PackContent key={sample.getId()} onDelete={onDelete} sample={sample}/>)}
             {presets.map(
                 preset =>
                     <PackContent key={preset.contentHash} onDelete={onDelete} preset={preset}/>)}
           </div>}
          <textarea
            onMouseDown={(e) => e.stopPropagation()}
            spellcheck="false"
            className="pack-description"
            onChange={(e) => setDescription(e.target.value)}
            type="textarea" value={description}/>
          <div
            onClick={onClickSave}
            className="save-button">
            Save
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      position: state.packs.windowPosition,
      sampleDragging: state.selector.sampleDragging,
      presetDragging: state.presets.presetDragging,
      creatingNewPack: state.packs.creatingNewPack
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setDraggingPackWindow: (x) => dispatch(setDraggingPackWindow(x)),
      setCreatingNewPack: (x) => dispatch(setCreatingNewPack(x)),
      setSampleDragging: (x) => dispatch(setSampleDragging(x)),
      setPresetDragging: (x) => dispatch(setPresetDragging(x)),
      setPackToEdit: x => dispatch(setPackToEdit(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPackWindow);
